export { getElementEventData, eventActionType } from './lib/analytics'
